<template>
  <v-sheet color="black">
    <v-container class="py-6">
      <v-responsive max-width="1200" class="mx-auto text-center mt-8">
        <h1 style="color: #FFFFFF; text-aling: center; font-size: 45px">
          {{ $t('testimony.title') }}
        </h1>
      </v-responsive>
      <v-row class="mt-6 mb-8">
        <v-col
          v-for="(item, i) in $t('customers.testimony')"
          :key="i"
          cols="12"
          sm="6"
          lg="6"
          justify="center"
          align=""
        >
          <v-card class="col-6 pa-3 d-flex">
            <div class="text-h3 mr-2">“</div>
            <div class="text-body-1">{{ item.testimonial }}</div>
          </v-card>
          <div
            :class="
              $vuetify.breakpoint.mdAndUp
                ? 'd-flex align-center mt-3'
                : 'd-flex align-center justify-center mt-3'
            "
          >
            <div class="mr-2">
              <v-avatar size="30">
                <v-img :src="testimonials[i].image"></v-img>
              </v-avatar>
            </div>
            <div>
              <div class="text-h7" style="color: #FFFFFF">{{ item.name }}</div>
              <div class="text-h8 white--text">{{ item.title }}</div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <div id="waveTopBlack"></div>
  </v-sheet>
</template>

<script>
import BernardoCastroVitorino from 'Assets/Landing/Bernardo_Castro_Vitorino.jpg';
import LeonardoCarvalho from 'Assets/Landing/Leonardo_Carvalho.jpg';
export default {
  data() {
    return {
      testimonials: [
        {
          image: BernardoCastroVitorino,
        },
        {
          image: LeonardoCarvalho,
        },
      ],
    };
  },
};
</script>
